export { default as GenericHubPageHeader } from './header/header'
